import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { DynamicComponent, GenericValue, HisAuthService } from 'hisng';

import { OrganizationPatent } from 'app/fs/res/patent/model/patent/patent-classes';
import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Component( {
    selector: 'res-patent-edit-registration-organizations',
    templateUrl: './patent-edit-registration-organizations.component.html',
} )
export class PatentEditRegistrationOrganizationsComponent implements OnChanges {
    @Input() organizations: OrganizationPatent[]; // ngModel
    @Input() isPriorityPatent = false;
    @Input() dynamicComponent: DynamicComponent;
    @Output() organizationsChange: EventEmitter<OrganizationPatent[]> = new EventEmitter();

    public internalOrganizations: GenericValue[];
    public externalOrganizations: ResearchPartnerSimple[];

    constructor( public auth: HisAuthService ) { }

    /* Component ngOnChanges() */
    ngOnChanges( changes: SimpleChanges ) {
        console.log( 'changes =', changes );
        if ( changes ) {
            // check if organizations of patent changed.
            this.setInternalOrganizations();
            this.setExternalOrganizations();
        }
    }

    /**
     * event handler implementation of selected internal/external organization
     *
     * @param event GenericValue[] as external organization units to set on patent
     */
    internalOrganizationsChange( event: GenericValue[] ): void {
        if ( this.organizations == null ) {
            this.organizations = new Array<OrganizationPatent>();
        }
        this.organizations = this.organizations.filter( o => o.organization == null );
        event.forEach( genericValueOrgUnit => {
            this.organizations = [...this.organizations, new OrganizationPatent( genericValueOrgUnit, null )];
        } );
        this.organizationsChange.emit( this.organizations );
    }

    /**
     * event handler implementation of selected external organization units
     *
     * @param isExtern boolean if organization is internal or external
     */
    externalOrganizationsChange( event: ResearchPartnerSimple[] ): void {
        if ( this.organizations == null ) {
            this.organizations = new Array<OrganizationPatent>();
        }
        this.organizations = this.organizations.filter( o => o.researchPartner == null );
        event.forEach( researchPartner => {
            this.organizations = [...this.organizations, new OrganizationPatent( null, researchPartner )];
        } );
        this.organizationsChange.emit( this.organizations );
    }

    /**
     * call back method implementation of deleteOrganizationChange
     *
     * @param event GenericValue | ResearchPartner, organization which was was deleted.
     */
    deleteOrganizationChange( event: GenericValue | ResearchPartnerSimple ): void {
        let index = this.organizations.findIndex( o => o.organization && o.organization.id === event.id
            || o.researchPartner && o.researchPartner.id === event.id );
        this.organizations.splice( index, 1 );
        this.organizationsChange.emit( this.organizations );
    }

    /* set filtered Array of internal organizations */
    setInternalOrganizations(): GenericValue[] {
        this.internalOrganizations = [];
        if ( this.organizations ) {
            this.organizations.forEach( o => {
                if ( o && o.organization != null ) {
                    this.internalOrganizations.push( o.organization );
                }
            } );
        }
        return this.internalOrganizations;
    }

    /* set filtered Array of external organizations */
    setExternalOrganizations(): ResearchPartnerSimple[] {
        this.externalOrganizations = [];
        if ( this.organizations ) {
            this.organizations.forEach( o => {
                if ( o && o.researchPartner != null ) {
                    this.externalOrganizations.push( o.researchPartner );
                }
            } );
        }
        return this.externalOrganizations;
    }
}
